export default "__VITE_ASSET__SdjANW1R__"